export const cacheKeys = {
  getDiscipline: 'getDiscipline',
  getDisciplines: 'getDisciplines',
  likeDiscipline: 'likeDiscipline',
  unlikeDiscipline: 'unlikeDiscipline',
  ignoreDiscipline: 'ignoreDiscipline',
};
